// extracted by mini-css-extract-plugin
export default {"dwellingUnitNumberSiteName":"location-sitename_dwellingUnitNumberSiteName__f-vHO"};